//@flow
import React from 'react';
import FloatLabelInput from '../../Form/components/FloatLabelInput.react';
import EmailField from '../../Address/components/EmailField.react';

type Props = {
  newUser?:boolean,
  formData?:Object,
  defaultEmail?:?string,
  isExistingUserEmail?:boolean,
  shouldRenderEmailPrompt?:boolean,
  placeholder?:string,
  emailPlaceholder?:string,
  emailDomainValidationError?:string,
};

function renderEmailPrompt(props) {
  if (props.shouldRenderEmailPrompt) {
    return (<div className="email-error">Please enter your email address</div>);
  }
}

function getPasswordClassName(props) {
  return props.isExistingUserEmail ? "-compact" : "";
}

function getEmailClassName(props) {
  return props.shouldRenderEmailPrompt ? " show-email-prompt" : "";
}

export default function LoginFormEmailPassword(props:Props) {
  let errorMessage;
  if (props.isExistingUserEmail) {
    errorMessage = (<span className="email-error">This email is already in use</span>);
  } else if (props.emailDomainValidationError) {
    errorMessage = (<span className="email-error">{props.emailDomainValidationError}</span>);
  }

  return (
    <div className="row">
      <EmailField
        className={"input-email" + getEmailClassName(props)}
        showFloat={true}
        placeholder={props.emailPlaceholder || 'Email'}
        setValue={props.defaultEmail || ''}
      />
      {errorMessage}
      {renderEmailPrompt(props)}
      <FloatLabelInput
        type="password"
        name="password"
        formData={props.formData}
        className={"input-password" + getPasswordClassName(props)}
        required={true}
        showFloat={true}
        placeholder={props.placeholder || "Password"}
        title="Password"
        validations="minLength:6"
        validationError="Password must be 6 characters"
      />
    </div>
  );
}
